import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AdvancedSearchContext } from "~/providers/AdvancedSearchProvider";
import FilterToggleTopic from "../ListToggle/FilterToggleTopic";
import SearchDialogModal from "~/features/SearchV3/components/SearchDialog/SearchDialogModal";
import SearchDialogForm from "~/features/SearchV3/components/SearchDialog/SearchDialogForm";
import useSolrMetaData from "~/features/SearchV3/hooks/useSolrMetaData";
import { isEqual } from "lodash";
import { useLocation } from "react-router-dom";
import { FilterOption } from "~/types/filters.types";

const ModalCompanies = () => {
    const { t } = useTranslation();
    const { companyFilters, setTriggerSearch } = useContext(AdvancedSearchContext);
    const { isModalOpen } = useSolrMetaData();
    const location = useLocation();

    // Temp list for changes before update event
    const [tempList, setTempList] = useState<FilterOption[]>(companyFilters);

    useEffect(() => {
        if (companyFilters.length !== tempList.length) setTempList(companyFilters);
    }, [companyFilters]);

    useEffect(() => {
        if (!isEqual(companyFilters, tempList)) {
            setTempList(companyFilters);
        }
    }, [companyFilters]);

    useEffect(() => {
        setTriggerSearch(true);
    }, [location.key]);

    const selectedCount = tempList.length;
    const firstSelected = tempList[0]?.label as string;
    const remainingCount = selectedCount > 1 ? selectedCount - 1 : 0;

    const truncateText = (text: string, maxLength = 40) => {
        return text.length > maxLength ? text.slice(0, maxLength - 3) + "..." : text;
    };

    let displayLabel: string;

    if (selectedCount === 0) {
        displayLabel = t("topic");
    } else if (remainingCount === 0) {
        displayLabel = truncateText(firstSelected);
    } else {
        displayLabel = `${truncateText(firstSelected)} +${remainingCount} more`;
    }

    return (
        <>
            <FilterToggleTopic label={displayLabel} count={selectedCount} panelWidth={"max-w-sm"} />
            <SearchDialogModal open={isModalOpen}>
                <SearchDialogForm />
            </SearchDialogModal>
        </>
    );
};

export default ModalCompanies;
